"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeActionsMenu = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const tree_actions_menu_styles_1 = require("./tree-actions-menu.styles");
const components_1 = require("../../../../components");
const localization_1 = require("../../../../../localization");
const TreeActionsMenu = ({ anchorEl, onClose, handleAddNode, handleDeleteNode, selectedProductTreeNode, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { totalProductsCount, isTerminalNode } = selectedProductTreeNode;
    const isDeleteDisabled = !isTerminalNode && totalProductsCount > 0;
    const deleteOption = (0, react_1.useMemo)(() => {
        if (isDeleteDisabled) {
            return (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, placement: "bottom", title: react_1.default.createElement(components_1.TooltipTitle, null, t({ key: 'DELETE_NODE_TOOLTIP' })) }, react_1.default.createElement("div", null, react_1.default.createElement(tree_actions_menu_styles_1.StyledMenuItem, { disabled: isDeleteDisabled }, t({ key: 'REMOVE_NODE' })))));
        }
        return react_1.default.createElement(tree_actions_menu_styles_1.StyledMenuItem, { onClick: handleDeleteNode }, t({ key: 'REMOVE_NODE' }));
    }, [handleDeleteNode, isDeleteDisabled, t]);
    return (react_1.default.createElement(material_1.Popover, { anchorEl: anchorEl, open: !!anchorEl, TransitionProps: {
            exit: false,
            unmountOnExit: true,
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, onClose: onClose }, react_1.default.createElement(tree_actions_menu_styles_1.StyledMenuItem, { onClick: handleAddNode }, t({ key: 'ADD_NODE' })), deleteOption));
};
exports.TreeActionsMenu = TreeActionsMenu;
